import React from "react";
import { Header } from "./Header";
import { ListaDocumentos } from "./ListaDocumentos";
import { ModalFirmar } from "../ModalFirmar";
import { ModalMensajeAlerta } from "../ModalMensajeAlerta";
import { ModalSubirArchivo } from "../ModalSubirArchivo/ModalSubirArchivo";
import { ModalExito } from "../ModalExito";
import { ModalRegistrarAsistencia } from "../../common/components";
import { ModalConsentimientoDatosMovil } from "../ModalConsentimientoDatosMovil";

const MisDocumentosMovil = () => {
	return (
		<React.Fragment>
			<Header />
			<ListaDocumentos />
			<ModalFirmar />
			<ModalMensajeAlerta />
			<ModalSubirArchivo />
			<ModalExito />
			<ModalRegistrarAsistencia />
			<ModalConsentimientoDatosMovil />
		</React.Fragment>
	);
};

export default MisDocumentosMovil;
